import { useQuery, useQueryClient } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { Connectivity, PentaDashboard } from '@volvogroup-internal/dashboard';
import { useTranslation } from 'react-i18next';

import Table from '@/components/Table';
import { getToken } from '@/config/MsalAuthConfig';
import { useFleetAccount } from '@/contexts/fleet-account/useFleetAccount';
import { getUnitsConnectivityStatusQueryOptions, getUnitsLastSeenQueryOptions } from '@/service/vpc/queryOptions';
import { client } from '@/service/vpc/vpcService';
import useConnectivityTable, { mapConnectivityTableData } from '@/tables/useConnectivityTable';

export const Route = createFileRoute('/_authenticated/_account/dashboard/connectivity/')({
  component: RouteComponent,
});

function RouteComponent() {
  const { i18n } = useTranslation();
  const queryClient = useQueryClient();

  const { fleetVerifiedUnits } = useFleetAccount();
  const { columns } = useConnectivityTable();

  const endCustomerUnitIds = fleetVerifiedUnits?.map((unit) => unit.endCustomerUnitId) || [];
  const { data, isLoading } = useQuery(getUnitsLastSeenQueryOptions({ endCustomerUnitIds }));
  const { data: connectivityStatusData } = useQuery(getUnitsConnectivityStatusQueryOptions({ endCustomerUnitIds }));

  const tableData = mapConnectivityTableData(data, connectivityStatusData, fleetVerifiedUnits || []);

  return (
    <div className="flex flex-col gap-6">
      <PentaDashboard
        client={{
          httpClient: {
            instance: client,
            getToken: getToken,
          },
          queryClient,
        }}
        language={i18n.language}
        preFilterUnits={endCustomerUnitIds}
      >
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          <Connectivity endCustomerUnitIds={endCustomerUnitIds} />
        </div>
      </PentaDashboard>
      <Table
        isLoading={isLoading}
        headerTitle={i18n.t(($) => $.pages.account.dashboard.connectivity.units_title)}
        data={tableData}
        columns={columns}
        showSearch={true}
        defaultSorting={[
          {
            id: 'lastSeen',
            desc: false,
          },
        ]}
      />
    </div>
  );
}
